import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=22d17bb7&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=22d17bb7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d17bb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d17bb7')) {
      api.createRecord('22d17bb7', component.options)
    } else {
      api.reload('22d17bb7', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=22d17bb7&scoped=true", function () {
      api.rerender('22d17bb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/admin/preview.vue"
export default component.exports